/**
 * @typedef {Object} LocationOrPosition
 * @property {LocationDescription} [locationDescription] - Already translated position & params
 */

/**
 * Helper function for formatting positions.
 *
 * @param {Object} intl - The modux intl
 * @param {LocationOrPosition} locationOrPosition - The object containing location or position information
 * @param {Object} [options] - Additional formatting options
 * @param {boolean} [options.asString=true] - Flag indicating whether the result should be formatted as a string (default: true)
 * @returns {string|null} The formatted position or null if no position description is available
 */
export function formatPosition(intl, { locationDescription }, { asString = true } = {}) {
    const wfUnknownLocation = intl.translate('wf_unknown_location')

    if (locationDescription?.address) {
        return locationDescription.address
    }

    return asString ? wfUnknownLocation : null
}
